<template>
  <div class="curtains">
    <div class="curtains__back"></div>
    <div class="curtains__left"></div>
    <div class="curtains__right"></div>
  </div>
</template>

<script>
  export default {
    name: 'Curtains',
  }
</script>